import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { EditEventQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import {
  BuildingStorefrontIcon,
  CalendarIcon,
  DocumentIcon,
  LightBulbIcon,
  PencilIcon,
  PhoneIcon,
  PhotoIcon,
  GlobeAltIcon
} from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from '@/components/event/edit_form'
import { EditContacts } from '@/components/event/edit_contacts'
import { EditShifts } from './edit_shifts'
import { EditKit } from './edit_kit'
import { EditStages } from './edit_stages'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { EditImages } from './edit_images'
import { EditDocuments } from './edit_documents'
import { EditPortfolioPage } from './edit_portfolio_page'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={id} />, icon: PencilIcon },
    { name: 'Stages', component: <EditStages eventId={id} />, icon: BuildingStorefrontIcon },
    { name: 'Kit', component: <EditKit eventId={id} />, icon: LightBulbIcon },
    { name: 'Contacts', component: <EditContacts eventId={id} />, icon: PhoneIcon },
    { name: 'Shifts', component: <EditShifts eventId={id} />, icon: CalendarIcon },
    { name: 'Images', component: <EditImages eventId={id} />, icon: PhotoIcon },
    { name: 'Documents', component: <EditDocuments id={id} />, icon: DocumentIcon },
    { name: 'Portfolio page', component: <EditPortfolioPage eventId={id} />, icon: GlobeAltIcon },
  ]

  const { data, loading } = useQuery<EditEventQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle><div>{ loading || !data ? <Loading /> : data.events.nodes[0].description }</div></DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
